import { render } from "./productoCard.vue?vue&type=template&id=1dbcf7d0&scoped=true"
import script from "./productoCard.vue?vue&type=script&lang=js"
export * from "./productoCard.vue?vue&type=script&lang=js"

import "./productoCard.vue?vue&type=style&index=0&id=1dbcf7d0&scoped=true&lang=css"
import "./productoCard.vue?vue&type=style&index=1&id=1dbcf7d0&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.41_vue@3.5.41_webpack@5.109.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dbcf7d0"]])

export default __exports__